<template>
   <modal @close="$emit('close')">
      <div slot="header"><span class="white-header">Wait!</span></div>

      <div slot="subhead"><span class="modal-title">{{subheadText}}</span></div>

      <div slot="body">
         <div class="modal-input-explain">{{message}}</div>
      </div>

      <div slot="footer">
         <button @click="saveClick" class="btn-yellow">Save</button>
         <button @click="leaveClick" class="btn-yellow">Leave</button>
         <button @click="cancelClick" class="btn-yellow">Cancel</button>
      </div>
   </modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Modal from './Modal';

export default {
   
   methods: {
      ...mapActions('global', [
         'handleUnsavedChangesModalSave',
         'handleUnsavedChangesModalLeave',
         'handleUnsavedChangesModalCancel'
      ]),

      saveClick() {
         this.handleUnsavedChangesModalSave({vm: this});
      },

      leaveClick() {
         this.handleUnsavedChangesModalLeave({vm: this});
      },

      cancelClick() {
         this.handleUnsavedChangesModalCancel({vm: this});
      }
   },

   props: {
      error: {
         type: Boolean,
         required: false,
         default: false
      },
      title: {
         type: String,
         required: false
      },
      headerText: {
         type: String,
         required: false
      },
      subheadText: {
         type: String,
         required: false
      },
      message: {
         type: String,
         required: false
      },
      list: {
         type: Array,
         required: false
      }
   },

   components: {
      Modal
   }
}
</script>

<style lang="scss" scoped>
   .modal-body {
      display: none;
   }

   .instance-title {
      color: $instance-font-color;
   }
</style>
